import GamesService from '@/services/games.service.ts'
import EventBus from '@/utils/EventBus'
import { isArrayEmpty, isStrEmpty } from '@/utils/utils.ts'
import routerMixins from '@/mixins/router/router-mixin'
import languageMixins from '@/mixins/language/language-mixins'
import { CTPayout } from '@/constants/payout'
import { buildCatalogue, productByRoute } from '@/constants/game/products'

export default {
    mixins: [routerMixins, languageMixins],
    data() {
        return {
            dataSource: [],
            limitEntry: -1,
            dataShowGame: [],
            dataGames: [],
            isPariMutuelLotto: false,
            loadingPage: true,
            gameSelect: '',
            isMultiLotto: false,
            step: 1,
            gameSlugActive: '',
        }
    },
    created() {
        this.fetchdata()
        EventBus.$on('on-change-game-screen-games', (value) => this.onChangeGame(value))
    },
    destroyed() {
        EventBus.$off('on-change-game-screen-games', this.onChangeGame)
    },
    methods: {
        async fetchdata() {
            try {
                const visibility = {
                    '5-90': this.$store.state.isShow590,
                    '4-80': this.$store.state.isShow480,
                    '4-52': this.$store.state.isShow452,
                    '6-45': this.$store.state.isShow645,
                    '5-45': this.$store.state.isShow545,
                    '4-59': this.$store.state.isShow459,
                }
                if (!Object.values(visibility).some(Boolean)) {
                    this.loadingPage = false
                    return false
                }
                const [respMulti, respPari] = await Promise.all([
                    GamesService.getListGames('multi-lotto'),
                    GamesService.getListGames('pari-mutuel-lotto'),
                ])
                const multiData = respMulti.code === 200 && !isArrayEmpty(respMulti.data) ? respMulti.data : []
                const pariData = respPari.code === 200 && !isArrayEmpty(respPari.data) ? respPari.data : []
                const resp = buildCatalogue(multiData, pariData).filter((item) => visibility[item.productKey])
                this.limitEntry = resp.find((item) => item.limitEntry > 0)?.limitEntry || -1
                this.dataSource = resp
                if (this.$router.history.current.name === 'Games-Loto') {
                    this.onChangeGame(this.$router.history.current.query?.loto)
                } else {
                    this.loadingPage = false
                }
            } catch (err) {
                this.loadingPage = false
                console.log(err, 'err')
            }
        },
        onChangeGame(value) {
            this.loadingPage = true
            if (value !== this.gameSelect) {
                const product = productByRoute(value)
                const isLotto590 = product?.key === '5-90'
                this.gameSelect = value
                this.isMultiLotto = Boolean(product && product.api === 'multi-lotto')

                this.dataShowGame = this.dataSource.filter((item) => item.route === product?.route)

                if (!isArrayEmpty(this.dataShowGame)) {
                    if(isLotto590) {
                        let item = {...this.dataShowGame[0]}
                        item['title'] = CTPayout.LOTTO_DOUBLE_CHANGE.title
                        item['isHiddenPlayGame'] = true
                        this.dataShowGame.push(item)
                    }
                    let param = {}
                    let configGames = localStorage.getItem('configGame')
                    if (!isStrEmpty(configGames)) {
                        param = JSON.parse(configGames)
                        localStorage.removeItem('configGame')
                    } else {
                        let item = this.dataShowGame[0]
                        const first = item.listRanDomNumber[0]
                        param = {
                            title: item.title,
                            gameNumber: first.number,
                            name: first.slug || item.name,
                            price: first?.price || item.price,
                            numberQp: item.title === 'turbo' ? 2 : first.number,
                            listRanDomNumber: item.listRanDomNumber,
                            bet_options: item.bet_options,
                            isPariMutuelLotto: item.isPariMutuelLotto,
                            productStep: item.productStep,
                            productKey: item.productKey,
                            gameType: item.gameType,
                            api: item.api,
                            balls: item.balls,
                            parentId: item.parentId,
                            preserveSlug: item.preserveSlug,
                            wagerConfig: first.wagerConfig || item.wagerConfig,
                        }

                        if (first?.allowed_picks) {
                            param['allowed_picks'] = first.allowed_picks
                            param['numberQp'] = first.allowed_picks?.max || param['numberQp']
                        }
                        
                        if (item.bankers && Array.isArray(item.bankers) && item.bankers.length > 0) {
                            param['bankers'] = item.bankers
                        } else if (first?.bankers && Array.isArray(first.bankers)) {
                            param['bankers'] = first.bankers
                        }

                        if (item.isPariMutuelLotto) {
                            param['maxPicks'] = first.maxPicks
                            param['numberQp'] = first.number
                            param['jackpot'] = item.jackpot
                        }
                    }

                    this.isPariMutuelLotto = param.isPariMutuelLotto
                    this.dataGames = param
                    this.gameSlugActive = value
                    this.step = 2
                    this.$store.dispatch('onSwitchBetslip', { step: product?.step || 1 })
                } else {
                    this.step = 1
                }
                this.loadingPage = false
            } else {
                this.loadingPage = false
            }
        },

        // utils
        onSetValueLimitEntry(data) {
            return data.game.parent?.account_limit || -1
        }
    },
}
